import styled from '@emotion/styled';

import { PrimaryTableRow } from '@Calix-Commerce/design-system/components';

export const TableRow = styled(PrimaryTableRow)`
  td {
    padding-top: 1.07rem;

    &:nth-of-type(2) {
      max-width: 300px;
    }

    img {
      width: 150px;
      margin-right: 0.72rem;
    }
  }
`;
